import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientNotificationFiltersModel } from '../../Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel';

declare var IS_RUNNING_IN_APP_POOL;

export class NotificationFilterReorderClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(request: Array<ClientNotificationFiltersModel>): Promise<Array<ClientNotificationFiltersModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/NotificationFilterReorder/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.put<Array<ClientNotificationFiltersModel>, any>(url, data);
  }
}

